window.breadcrumbsModule = (() => {
  const breadcrumbs = document.querySelector("nav.breadcrumbs");

  const removeHomeBreadcrumb = () => {
    const homeBreadCrumb = Array.from(breadcrumbs.querySelectorAll("a")).find(
      (link) => link.textContent.trim() === "Home"
    );

    const spanAfterHome =
      homeBreadCrumb?.nextElementSibling.tagName === "SPAN" ? homeBreadCrumb.nextElementSibling : null;
  };

  const init = () => {};

  init();

  return true;
})();
